export const EnumProduktauswahl = Object.freeze({
  HAUSRAT: 0,
  GLAS: 1,
});

export const EnumNeuordnung = Object.freeze({
  HAUSRAT: 0,
  KOMBI: 1,
  GLAS: 2,
});

export const EnumGlasversicherung = Object.freeze({
  MOBILIAR: 0,
  GEBAEUDE: 1,
});

export const EnumSb = Object.freeze({
  NULL: 1,
  ZWEIFUENF: 2,
  FUENF: 4,
  TAU: 5,
  ZWEITAUFUENF: 6,
});
